/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from 'react';
import { Tooltip } from '@mui/material';
import IconButton from './IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigationHistory } from 'hooks/navigation.hook';
import { useLocation } from 'react-router-dom';
import { RoutesConstants} from '@malmur-technologies/medicalsystem-shared';
import { getRouteDisplayNames} from 'constants/routes.const';
import { t } from 'i18next';

interface SmartBackButtonProps {
  sx?: object;
  iconColor?: string;
}

const SmartBackButton: React.FC<SmartBackButtonProps> = ({ 
  sx = {},
  iconColor = 'inherit',
}) => {
  const { navigateBack, getHistory, canGoBack } = useNavigationHistory();
  const location = useLocation();
  const getRouteDisplayName = (route: string): string => {
    const ROUTE_DISPLAY_NAMES = getRouteDisplayNames();
    const routeKey = Object.values(RoutesConstants).find(r => r === route) as RoutesConstants;
    if (routeKey && ROUTE_DISPLAY_NAMES[routeKey]) {
      return ROUTE_DISPLAY_NAMES[routeKey];
    }
    const segments = route.split('/').filter(segment => segment);
    if (segments.length === 0) return 'Home';
    const lastSegment = segments[segments.length - 1];
    return lastSegment
      .replace(/-/g, ' ')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase()) || 'Unknown Page';
  };

  const getTooltipText = (): string => {
    const history = getHistory();
    const currentPath = location.pathname;
    let previousRoute = null;
    for (let i = history.length - 1; i >= 0; i--) {
      const entry = history[i];
      if (entry.route !== currentPath) {
        previousRoute = entry.route;
        break;
      }
    }
    if (previousRoute) {
      const routeName = getRouteDisplayName(previousRoute);
      return `${t("common.backTo")} ${routeName}`;
    }    
    const dashboardName = getRouteDisplayName(RoutesConstants.DASHBOARD);
    return `${t("common.backTo")} ${dashboardName}`;
  };
  if (!canGoBack()) {
    return null;
  }
  return (
    <Tooltip title={getTooltipText()} placement="bottom">
      <IconButton
        id="cy-back-button"
        onClick={navigateBack}
        size="small"
        disableRipple
        aria-label="Go back"
        sx={sx}
      >
        <ArrowBackIcon fontSize="small" sx={{ color: iconColor }} />
      </IconButton>
    </Tooltip>
  );
};
export default SmartBackButton;